import { Directive, EventEmitter, HostListener, Output } from '@angular/core';
import { LONG_PRESS_DURATION_MS } from 'src/app/core/helpers/ui/ui.constant';

@Directive({
  selector: '[longPress]',
})
export class LongPressDirective {
  @Output() longPress: EventEmitter<void> = new EventEmitter();

  private timeoutId?: ReturnType<typeof setTimeout>;

  @HostListener('pointerdown')
  onPointerDown(): void {
    this.timeoutId = setTimeout(() => this.longPress.emit(), LONG_PRESS_DURATION_MS);
  }

  @HostListener('pointerup')
  @HostListener('pointerleave')
  @HostListener('pointercancel')
  onPointerRelease(): void {
    clearTimeout(this.timeoutId);
  }
}
